import InstagramCustomSettingsEntity from "@apps/instagram/entities/InstagramCustomSettingsEntity";
import InstagramDisplaySettingsEntity from "@apps/instagram/entities/InstagramDisplaySettingsEntity";
import { Observable, combineLatest } from "rxjs";
import { map } from "rxjs/operators";

export const combineSettings = (
    displaySettings$: Observable<InstagramDisplaySettingsEntity | null>,
    customSettings$: Observable<InstagramCustomSettingsEntity>
): Observable<
    | (InstagramDisplaySettingsEntity & InstagramCustomSettingsEntity)
    | InstagramCustomSettingsEntity
> => {
    return combineLatest(displaySettings$, customSettings$).pipe(
        map(([displaySettings, customSettings]) => {
            return { ...customSettings, ...displaySettings };
        })
    );
};
